import { render } from "./sections_field.vue?vue&type=template&id=4a858a78&lang=pug"
import script from "./sections_field.vue?vue&type=script&lang=js"
export * from "./sections_field.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__